import type { StaticApplicationsFooterBffNewsletterSubscriptionConfigurationDto } from '@ori/static-api-client-react';

import { NewsletterTitleIconType } from '../../../TitleIcon';
import { ButtonAction, SubscriptionProcessStatus } from '../../types';
import { type Content } from './types';

interface GetContentParams {
  newsletterSubsciptionConfiguration?: StaticApplicationsFooterBffNewsletterSubscriptionConfigurationDto | undefined;
  status: SubscriptionProcessStatus;
}
export const getContent = ({ newsletterSubsciptionConfiguration, status }: GetContentParams): Content => {
  const { submitDialog, subscribedDialog, errorDialog } = newsletterSubsciptionConfiguration ?? {};

  const content = {
    title: submitDialog?.headline,
    icon: NewsletterTitleIconType.Submit,
    text: submitDialog?.text,
    showForm: true,
    showButton: true,
    buttonText: submitDialog?.subscribeButtonText,
    buttonAction: ButtonAction.Submit,
    ppText: submitDialog?.privacyPolicyText ?? '',
    ppLinkText: submitDialog?.privacyPolicyUrlText ?? '',
    ppUrl: submitDialog?.privacyPolicyUrl ?? '',
    invalidEmailLabel: submitDialog?.invalidEmailLabel ?? 'Invalid email',
    emailLabel: submitDialog?.emailLabel ?? 'Email',
  };

  if (status === SubscriptionProcessStatus.Subscribed) {
    content.title = subscribedDialog?.headline;
    content.icon = NewsletterTitleIconType.Subscribe;
    content.text = subscribedDialog?.text;
    content.showForm = false;
    content.showButton = false;
    content.buttonText = '';
    content.buttonAction = ButtonAction.None;
    content.ppText = '';
    content.ppLinkText = '';
    content.ppUrl = '';
  }

  if (status === SubscriptionProcessStatus.Failed) {
    content.title = errorDialog?.headline;
    content.icon = NewsletterTitleIconType.Error;
    content.text = '';
    content.showForm = false;
    content.showButton = true;
    content.buttonText = errorDialog?.buttonText;
    content.buttonAction = ButtonAction.Reset;
    content.ppText = '';
    content.ppLinkText = '';
    content.ppUrl = '';
  }

  return content;
};
